import { render, staticRenderFns } from "./ModalDesempateEtapaFechada.vue?vue&type=template&id=61e2b9c8&scoped=true"
import script from "./ModalDesempateEtapaFechada.vue?vue&type=script&lang=js"
export * from "./ModalDesempateEtapaFechada.vue?vue&type=script&lang=js"
import style0 from "./ModalDesempateEtapaFechada.vue?vue&type=style&index=0&id=61e2b9c8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e2b9c8",
  null
  
)

export default component.exports